import { render, staticRenderFns } from "./Liff.vue?vue&type=template&id=371cd382&scoped=true&"
import script from "./Liff.vue?vue&type=script&lang=ts&"
export * from "./Liff.vue?vue&type=script&lang=ts&"
import style0 from "./Liff.vue?vue&type=style&index=0&id=371cd382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371cd382",
  null
  
)

export default component.exports